module.exports = __webpack_public_path__ + "img/labvida.619038cb.png";